[
  {
    "id": "SWW-M7P-L204-001",
    "module": "SpellingWW",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Het huis wordt ... (bouwen).",
    "options": ["gebouwd", "gebouwt", "gebouwen", "bouwde"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "passief_tegenwoordige_tijd",
    "familyId": "SWW-VD-DT-REGEL-NIET_TKOF",
    "conceptId": "past_participle_d_or_t_not_tkofschip",
    "variantIndex": 1,
    "explanation": "Je zoekt het voltooid deelwoord van **bouwen** in een passieve zin: *wordt gebouwd*.\n\nStap 1: stam = **bouw**.\nStap 2: kijk naar de **laatste letter van de stam** (w). Die zit **niet** in ’t kofschip.\nStap 3: dan krijgt het voltooid deelwoord **-d**: **ge-bouw-d** → **gebouwd**.",
    "distractorExplanations": {
      "1": "**-t** gebruik je bij werkwoorden in de tegenwoordige tijd (*hij bouwt*). Hier heb je een **voltooid deelwoord** nodig na *wordt*.",
      "2": "**Gebouwen** is het hele werkwoord (infinitief/meervoud van gebouw). In de zin met *wordt* hoort een voltooid deelwoord: *wordt gebouwd*.",
      "3": "**Bouwde** is verleden tijd (*hij bouwde*). In een passieve zin met *wordt* gebruik je geen verleden tijd maar een voltooid deelwoord."
    }
  },
  {
    "id": "SWW-M7P-L204-002",
    "module": "SpellingWW",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "De ... auto (verbranden).",
    "options": ["verbrande", "verbrandde", "verbrand", "verbrandt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "bijvoeglijk_deelwoord",
    "subSkill": "bijvoeglijk_gebruikt_vd",
    "familyId": "SWW-BNVD-VD-ALS_BIJVOEGLIJK-DE_WOORD",
    "conceptId": "past_participle_used_as_adjective_with_e",
    "variantIndex": 1,
    "explanation": "Hier staat het voltooid deelwoord **bijvoeglijk** bij *auto*.\nHet basisvorm is **verbrand** (voltooid deelwoord).\nOmdat het gaat om **de auto** (een *de-woord*), krijgt het bijvoeglijk gebruikte deelwoord meestal **-e**: **de verbrande auto**.",
    "distractorExplanations": {
      "1": "**Verbrandde** is verleden tijd (ik verbrandde / hij verbrandde). Dat past niet als bijvoeglijk woord voor *auto*.",
      "2": "**Verbrand** is de basisvorm (voltooid deelwoord), maar bij **de auto** hoort doorgaans een **-e**: *de verbrande auto*.",
      "3": "**Verbrandt** is tegenwoordige tijd (hij verbrandt). In deze zin beschrijf je een toestand van de auto, niet een handeling in het nu."
    }
  },
  {
    "id": "SWW-M7P-L204-003",
    "module": "SpellingWW",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Hij ... op het antwoord. (wachten)",
    "options": ["wachtte", "wachtde", "wacht", "gewacht"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verleden_tijd",
    "subSkill": "zwakke_werkwoorden_stam_plus_te",
    "familyId": "SWW-VT-ZWAK-STAM_EINDIGT_OP_T-TE",
    "conceptId": "past_tense_weak_verb_stem_ends_with_t",
    "variantIndex": 1,
    "explanation": "Je zoekt de verleden tijd van **wachten**.\n\nStap 1: stam = **wacht**.\nStap 2: verleden tijd van zwakke werkwoorden: **stam + te/de**.\nStap 3: stam eindigt op **t** (en t zit in ’t kofschip) → je kiest **-te**.\nMaar omdat de stam al op **t** eindigt, krijg je **tt**: **wacht + te = wachtte**.",
    "distractorExplanations": {
      "1": "**Wachtde** ontstaat als je ‘-de’ kiest of de dubbele t vergeet. Bij een stam op **t** wordt het **-te** én krijg je **tt**.",
      "2": "**Wacht** is tegenwoordige tijd (hij wacht). De zin vraagt verleden tijd: “Hij … op het antwoord.”",
      "3": "**Gewacht** is het voltooid deelwoord. Dat gebruik je met *heeft/had*: “Hij **heeft** gewacht.”"
    }
  },
  {
    "id": "SWW-M7P-L204-004",
    "module": "SpellingWW",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "De man ... de hond. (redden)",
    "options": ["redde", "redte", "redt", "gered"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verleden_tijd",
    "subSkill": "zwakke_werkwoorden_stam_plus_de",
    "familyId": "SWW-VT-ZWAK-STAM_EINDIGT_OP_D-DE",
    "conceptId": "past_tense_weak_verb_stem_ends_with_d",
    "variantIndex": 1,
    "explanation": "Je zoekt de verleden tijd van **redden**.\n\nStap 1: stam = **red**.\nStap 2: verleden tijd = stam + **te/de**.\nStap 3: stam eindigt op **d** (niet in ’t kofschip) → je kiest **-de**.\nOmdat de stam al op **d** eindigt, krijg je **dd**: **red + de = redde**.",
    "distractorExplanations": {
      "1": "**Redte** krijg je als je ‘-te’ kiest. Maar de stam eindigt op **d**, dus je kiest **-de** (niet -te).",
      "2": "**Redt** is tegenwoordige tijd (hij redt). De zin gaat over iets dat al gebeurd is → verleden tijd.",
      "3": "**Gered** is voltooid deelwoord. Dat gebruik je met *heeft/had*: “De man **heeft** de hond gered.”"
    }
  },
  {
    "id": "SWW-M7P-L204-005",
    "module": "SpellingWW",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "De taart is ... (snijden).",
    "options": ["gesneden", "gesneeden", "gesnijd", "snijdt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "sterke_werkwoorden_onregelmatig",
    "familyId": "SWW-VD-STERK-ONREGELMATIG",
    "conceptId": "past_participle_strong_irregular",
    "variantIndex": 1,
    "explanation": "**Snijden** is een **sterk** (onregelmatig) werkwoord.\nHet voltooid deelwoord is niet *gesnij…* maar **gesneden**.\nJe gebruikt dit met *is/heeft*: “De taart **is gesneden**.”",
    "distractorExplanations": {
      "1": "**Gesneeden** is een fout gespelde verdubbeling. De juiste vorm is **gesneden** (één e na sn).",
      "2": "**Gesnijd** lijkt logisch als je de stam *snijd-* gebruikt, maar sterke werkwoorden hebben vaak een vaste vorm. Hier is dat **gesneden**.",
      "3": "**Snijdt** is tegenwoordige tijd (hij snijdt). In de zin met “is …” hoort juist het voltooid deelwoord."
    }
  }
]
